import { all, fork } from 'redux-saga/effects'
// main
import product from '@redux/saga/main/product.saga'
import bom from '@redux/saga/main/bom.saga'
import season from '@redux/saga/main/season.saga'
import seasonProduct from '@redux/saga/main/seasonProduct.saga'
import order from '@redux/saga/main/order.saga'
import coupon from '@redux/saga/main/coupon.saga'
import customer from '@redux/saga/main/customer.saga'
import inquiryMgmt from '@redux/saga/main/inquiryMgmt.saga'
// @PLOP-IMPORTS

export default function* rootSaga() {
	yield all([
		fork(product),
		fork(bom),
		fork(season),
		fork(seasonProduct),
		fork(order),
		fork(coupon),
		fork(customer),
		fork(inquiryMgmt),
		// @PLOP-CODE
	])
}
